import React, { ReactElement } from "react";
const Letter = ({ fill }: { fill?: string }): ReactElement => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="61">
            <g fill="none">
                <path
                    fill="#FFF"
                    d="m2.593 58.279-.954-1.013V33.934l6.918-6.082-.956-8.672.956-1.967 13.593-1.475 5.247-4.672h.715l3.101 1.967 1.908.707 10.971-.707h1.431l1.567 1.589.818 13.23 6.876 5.099v24.315l-.675 1.013-1.193 1.229z"
                />
                <path
                    fill={fill ?? "#C145A5"}
                    stroke={fill ?? "#C145A5"}
                    d="m.984 33.593.48-.927 21.84 12.092-.479.927zM31.966 44.757l21.842-12.09.48.927-21.842 12.09z"
                />
                <path
                    fill={fill ?? "#C145A5"}
                    d="M50.785 59.508c1.271-.002 2.408-.816 2.847-2.04L28.952 42.72a2.98 2.98 0 0 0-3.054-.01L1.162 57.265c.351 1.22 1.393 2.098 2.63 2.213l3.678.03h43.314z"
                />
                <path
                    fill={fill ?? "#C145A5"}
                    stroke={fill ?? "#C145A5"}
                    d="M51.026 60H4.246C2.28 59.998.686 58.351.685 56.32V33.188c0-.155.065-.302.18-.402l6.557-5.737.657.803-6.378 5.58V56.32c.002 1.451 1.14 2.627 2.542 2.629h46.782c1.404-.002 2.541-1.178 2.543-2.629V33.431l-6.107-5.348.658-.802 6.286 5.506c.114.1.18.246.18.4V56.32c-.003 2.031-1.595 3.678-3.56 3.68zM21.83 15.738l-.633-.801.748-.589 4.046-3.415a2.556 2.556 0 0 1 3.303 0l3.35 2.807-.656.78-3.353-2.807a1.535 1.535 0 0 0-1.984 0l-4.82 4.025z"
                />
                <path
                    fill={fill ?? "#C145A5"}
                    stroke={fill ?? "#C145A5"}
                    d="M8.357 37.377 6.425 19.24c-.154-1.436.846-2.728 2.233-2.887l35.164-4.042c1.388-.159 2.637.876 2.791 2.31l2.25 21.207-1.007.1-.183-1.968-2.065-19.223c-.092-.861-.842-1.482-1.674-1.386L8.77 17.392c-.832.097-1.43.872-1.34 1.732l1.933 18.139-1.005.114z"
                />
                <path
                    fill="#333"
                    d="m25.343 0 1.116 2.186 2.37-.416-1.68 1.766 1.117 2.185-2.154-1.094-1.679 1.766.348-2.441-2.154-1.094 2.368-.416zm-8.109 6.885 1.117 2.186 2.368-.415-1.679 1.766 1.117 2.185-2.154-1.094-1.678 1.766.347-2.442-2.154-1.094 2.368-.415zm17.648-3.442L36 5.628l2.37-.415-1.68 1.766 1.117 2.185-2.154-1.094-1.679 1.766.347-2.442-2.153-1.093 2.368-.416z"
                />
                <g fill={fill ?? "#C145A5"}>
                    <path
                        stroke={fill ?? "#C145A5"}
                        d="M22.655 26.558c-.268 0-.49-.23-.504-.526-.015-.295.182-.55.45-.582l19.023-2.332a.488.488 0 0 1 .462.224.6.6 0 0 1 .055.552.514.514 0 0 1-.406.33l-19.024 2.329c-.019.002-.038.004-.056.004zm.475 4.426c-.267 0-.488-.23-.502-.525-.015-.295.182-.55.448-.583L42.1 27.545c.277-.034.526.186.557.49.03.306-.17.58-.446.615l-19.024 2.33a.352.352 0 0 1-.056.004zm-7.615 1.475c-.725 0-1.335-.586-1.417-1.36l-.42-4.05c-.085-.837.478-1.591 1.26-1.685l2.362-.282.104 1.013-2.36.28c-.262.033-.45.284-.42.563l.42 4.05a.516.516 0 0 0 .174.34.453.453 0 0 0 .35.11l3.778-.45c.26-.032.448-.283.42-.562l-.264-2.531.945-.112.262 2.53c.086.839-.477 1.594-1.259 1.687l-3.778.45c-.053.006-.105.01-.158.01z"
                    />
                    <path d="M17.1 29.508a.482.482 0 0 1-.317-.12l-1.12-.961a.572.572 0 0 1-.08-.766.485.485 0 0 1 .714-.085l.724.622 3.27-4.387a.493.493 0 0 1 .474-.198c.18.03.33.16.396.34a.58.58 0 0 1-.076.54l-3.588 4.81a.491.491 0 0 1-.397.204z" />
                </g>
            </g>
        </svg>
    );
};

export default Letter;
